import React, { Component } from 'react'
import { createTrackConfig } from '../tmpTrack'
import { withReactTrack } from '@du/analytics-sdk'

import styles from '../index.module.less'
interface IProductItemProps {
  index: any
  spuId: any
  title: string
  itemNo: any
  cover: any
  price: any
  handleCover: any
  handlePrice: any
  getCurrency: any
  goDetail: any
  getRef?: any
  globalConfig?: any
  pageId?: any
  showPrice?: boolean
}

@withReactTrack({ createTrackConfig })
class ProductItem extends Component<IProductItemProps, { isSupportLoading: boolean }> {
  constructor(props) {
    super(props)
    this.state = {
      isSupportLoading: true,
    }
  }
  componentDidMount() {
    this.setState({
      isSupportLoading: 'loading' in new Image(),
    })
  }

  render() {
    const {
      index,
      // 以上为埋点接口
      spuId,
      title,
      itemNo,
      cover,
      price,
      handleCover,
      handlePrice,
      getCurrency,
      goDetail,
      getRef,
      showPrice,
    } = this.props
    return (
      <div
        ref={getRef}
        className={styles.item}
        key={spuId}
        data-track-exposure="poizon_venue_component_content_exposure"
        data-track-click="poizon_venue_component_content_click"
        data-index={index}
        onClick={() => goDetail({ spuId, index, title }, itemNo)}
      >
        <div className={styles['cover-box']}>
          {this.state.isSupportLoading ? (
            <img className={styles.cover} data-layzload-src={handleCover(cover)} alt="" />
          ) : (
            <img className={styles.cover} src={handleCover(cover)} alt="" />
          )}
        </div>
        <div className={styles['spu-title']}>{title}</div>
        {showPrice && (
          <div className={styles.info}>
            <div className={styles.price}>
              {getCurrency()}&nbsp;{handlePrice(price)}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default ProductItem
